import { Collection } from 'src/app/models/collection';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { GetCollections, ResetStore } from './collections.actions';
import { patch } from '@ngxs/store/operators';
import { CollectionsService } from './collections.service';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export type CollectionsStateModel = {
  collections: Collection[];
};

export const initialState: CollectionsStateModel = {
  collections: [],
};

@State<CollectionsStateModel>({
  name: 'collections',
  defaults: initialState,
})
@Injectable()
export class CollectionsState {
  private readonly collectionsService = inject(CollectionsService);

  @Selector()
  static collections(state: CollectionsStateModel) {
    return state.collections;
  }

  @Action(GetCollections)
  getCollections(context: StateContext<CollectionsStateModel>, { locale }: GetCollections): Observable<Collection[]> {
    return this.collectionsService.getCollections(locale).pipe(
      tap((collections) => {
        context.setState(patch<CollectionsStateModel>({ collections }));
      }),
      map(() => context.getState().collections)
    );
  }

  @Action(ResetStore)
  resetStore(context: StateContext<CollectionsStateModel>) {
    context.setState(initialState);
  }
}
